export const APP_NAME = 'DropLaunch'
export const APP_TAGLINE = 'AI-Powered Shopify Store Builder'

export const TRIAL_DAYS = 14
export const SUBSCRIPTION_PRICE = 5
export const SUBSCRIPTION_PERIOD = 'month'

export const PAYMENT_METHODS = {
  usdt_trc20: {
    label: 'USDT (TRC20)',
    network: 'Tron Network',
    icon: '₮',
    color: '#26A17B',
  },
  eth: {
    label: 'ETH (Ethereum)',
    network: 'Ethereum Mainnet',
    icon: 'Ξ',
    color: '#627EEA',
  },
  whish: {
    label: 'Whish Money',
    network: 'Lebanon',
    icon: '₤',
    color: '#E31E35',
  },
} as const

export const STORE_TYPES = [
  { value: 'dropshipping', label: 'Dropshipping', description: 'AliExpress, CJ Dropshipping, DSers', icon: '🚚' },
  { value: 'pod', label: 'Print on Demand', description: 'Printful, Printify custom products', icon: '🎨' },
  { value: 'physical', label: 'Physical Products', description: 'Own inventory & warehouse', icon: '📦' },
  { value: 'digital', label: 'Digital Products', description: 'eBooks, courses, templates', icon: '💾' },
  { value: 'services', label: 'Services', description: 'Bookings, consultations', icon: '🤝' },
  { value: 'wholesale', label: 'Wholesale / B2B', description: 'Bulk orders, trade pricing', icon: '🏭' },
  { value: 'hybrid', label: 'Hybrid', description: 'Mix of multiple types', icon: '⚡' },
] as const

export const BUDGET_RANGES = [
  { value: 'under_500', label: 'Under $500' },
  { value: '500_2000', label: '$500 - $2,000' },
  { value: '2000_5000', label: '$2,000 - $5,000' },
  { value: '5000_plus', label: '$5,000+' },
] as const

export const WIZARD_STEPS = [
  { number: 1, title: 'Store Basics', description: 'Brand name, tagline, meta info', icon: '🏪' },
  { number: 2, title: 'Product Setup', description: 'Add your first products', icon: '📦' },
  { number: 3, title: 'Store Pages', description: 'About, FAQ, Policies', icon: '📄' },
  { number: 4, title: 'Navigation', description: 'Menus and links', icon: '🧭' },
  { number: 5, title: 'Theme & Branding', description: 'Colors, logo, design', icon: '🎨' },
  { number: 6, title: 'Checkout & Payments', description: 'Payment methods', icon: '💳' },
  { number: 7, title: 'Shipping', description: 'Shipping zones and rates', icon: '🚚' },
  { number: 8, title: 'Trust & Compliance', description: 'Build customer trust', icon: '🛡️' },
  { number: 9, title: 'Marketing Pixels', description: 'Analytics and tracking', icon: '📊' },
  { number: 10, title: 'Recommended Apps', description: 'Essential Shopify apps', icon: '🔌' },
] as const

export const RATE_LIMITS = {
  ai: 10, // requests per minute
  shopify: 60, // requests per minute
} as const

export const API_ROUTES = {
  auth: {
    login: '/api/auth/login',
    register: '/api/auth/register',
    logout: '/api/auth/logout',
    me: '/api/auth/me',
    refresh: '/api/auth/refresh',
  },
  shopify: {
    products: '/api/shopify/products',
    orders: '/api/shopify/orders',
    customers: '/api/shopify/customers',
    analytics: '/api/shopify/analytics',
    pages: '/api/shopify/pages',
    menus: '/api/shopify/menus',
    store: '/api/shopify/store',
  },
  claude: {
    chat: '/api/claude/chat',
    generate: '/api/claude/generate',
    analyze: '/api/claude/analyze',
  },
  payments: {
    submit: '/api/payments/submit',
    history: '/api/payments/history',
    upload: '/api/payments/upload',
  },
  admin: {
    users: '/api/admin/users',
    payments: '/api/admin/payments',
    broadcast: '/api/admin/broadcast',
    stats: '/api/admin/stats',
  },
} as const

export const COLORS = {
  background: '#0f172a',
  surface: '#1e293b',
  primary: '#2563eb',
  ai: '#7c3aed',
  foreground: '#f8fafc',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
} as const
